module.exports = __webpack_public_path__ + "static/media/facebook-ico.f1cc87a1.svg";